module.exports = __webpack_public_path__ + "static/media/monkey.25e94c9a.jpeg";